import React from 'react';
import PropTypes from 'prop-types';
import { mergeStyles, Stack } from '@bingads-webui-react/fabric-control';
import { CloseIconButton } from './close-icon-button';

const headerTextStyles = mergeStyles({
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: 20,
  lineHeight: 26,
});

export const Header = ({ text, onCloseButtonClick, i18n }) => (
  <Stack horizontal horizontalAlign="space-between" verticalAlign="center" styles={{ root: { marginBottom: 8 } }}>
    <div className={headerTextStyles}>
      {text}
    </div>
    {onCloseButtonClick && <CloseIconButton closeButtonAriaLabel={i18n.getString('CloseButtonAria')} onClick={onCloseButtonClick} />}
  </Stack>
);

Header.propTypes = {
  text: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onCloseButtonClick: PropTypes.func,
};

Header.defaultProps = {
  onCloseButtonClick: null,
};
